import React from 'react'
import { Grid, Message, Icon } from 'semantic-ui-react'

let styles = {}

// !FIXME - Figure out why Brandon used Grid, shame him for it, then remove.
const ErrorMessage = ({ icon, header, content }) => (
  <Grid columns={1} centered padded>
    <Grid.Column style={styles.errorWrapper}>
      <Message icon size="large">
        <Icon as="span" name={icon} size="large" className="mobile hidden" />
        <Message.Content>
          <Message.Header>{header}</Message.Header>
          {content}
        </Message.Content>
      </Message>
    </Grid.Column>
  </Grid>
)

styles = {
  errorWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  }
}

export default ErrorMessage



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerGrid/components/FlyerGridBody/components/ErrorMessage.js